import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assests/css/students/Principal/PrincipalAchivement.css";
import { Icon0Circle } from "react-bootstrap-icons";

// Same-style inline icons as used across the theme (line icons, blue accent)
const IconGraduationCap = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 3L1 8l11 5 9-4.09V17h2V8L12 3z"
      fill="currentColor"
    />
    <path
      d="M5 10.18v4.7C5 17.5 8.13 19 12 19s7-1.5 7-4.12v-4.7l-7 3.18-7-3.18z"
      fill="currentColor"
    />
  </svg>
);

const IconTrophy = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 2h-3V1H9v1H6v3c0 2.02 1.14 3.77 3.06 4.6.36 1.87 1.7 3.4 3.44 3.98V17H9v2h6v-2h-2.5v-2.42c1.74-.58 3.08-2.11 3.44-3.98C18.86 9.77 20 8.02 20 6V2h-2zM8 6c0-.55.45-1 1-1v3.87C7.83 8.4 8 7.24 8 6zm8 0c0 1.24.17 2.4-1 2.87V5c.55 0 1 .45 1 1zM7 21h10v2H7z"
      fill="currentColor"
    />
  </svg>
);

const IconDocument = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
      fill="currentColor"
    />
    <path d="M14 2v6h6" fill="white" opacity="0.35" />
  </svg>
);

const IconWomen = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="7" r="4" fill="currentColor" />
    <path
      d="M12 13c-4.42 0-8 2.24-8 5v3h16v-3c0-2.76-3.58-5-8-5z"
      fill="currentColor"
    />
  </svg>
);

// Achievement data — swap these values with real content when available
const achievements = [
  {
    id: 1,
    icon: <IconGraduationCap />,
    title: "Academic Excellence",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    year: "2024",
  },
  {
    id: 2,
    icon: <IconTrophy />,
    title: "Leadership Award",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    year: "2024",
  },
  {
    id: 3,
    icon: <IconDocument />,
    title: "Research Publications",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    year: "2024",
  },
  {
    id: 4,
    icon: <IconWomen />,
    title: "Women's Education Promotion",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    year: "2023",
  },
    {
    id: 4,
    icon: <Icon0Circle />,
    title: "Women's Education Promotion",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    year: "2023",
  },
    {
    id: 4,
    icon: <IconWomen />,
    title: "Women's Education Promotion",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    year: "2023",
  },
];

const AchievementsSection = () => {
  return (
    <section className="achievements-section">
      <Container>
        <Row>
          <Col xs={12}>
            <h2 className="achievements-heading">Achievements Section</h2>
          </Col>
        </Row>

        <Row className="g-4 achievements-row">
          {achievements.map((item) => (
            <Col xs={12} md={6} key={item.id}>
              <div className="achievement-card">
                <div className="achievement-icon">{item.icon}</div>
                <div className="achievement-content">
                  <h3 className="achievement-title">{item.title}</h3>
                  <p className="achievement-description">
                    {item.description}
                  </p>
                  <span className="achievement-year">{item.year}</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default AchievementsSection;